<template>
  <div class="selectair-app">
    <!-- Embedded component mode (when data-page is set to contact or quote) -->
    <ContactForm v-if="isEmbeddedPage && embedPage === 'contact'" />
    <QuoteForm v-if="isEmbeddedPage && embedPage === 'quote'" />
    <AgentFinder v-if="isEmbeddedPage && embedPage === 'agent-finder'" />
    <DestinationSelector v-if="isEmbeddedPage && embedPage === 'destination-selector'" />
    <VacationSearch v-if="isEmbeddedPage && embedPage === 'vakanties'" />
    <VacationQuiz v-if="isEmbeddedPage && embedPage === 'vakantie-quiz'" />

    <!-- Normal router mode (for full application) -->
    <router-view v-if="!isEmbeddedPage"></router-view>

    <!-- Toast notifications (always visible) -->
    <ToastNotification ref="toast" />
  </div>
</template>

<script>
import ContactForm from './components/ContactForm.vue'
import QuoteForm from './components/QuoteForm.vue'
import AgentFinder from './views/AgentFinder.vue'
import DestinationSelector from './components/DestinationSelector.vue'
import ToastNotification from './components/ToastNotification.vue'
import VacationSearch from './views/index.vue'
import VacationQuiz from './views/VacationQuiz.vue'

export default {
  name: "App",
  components: {
    ContactForm,
    QuoteForm,
    AgentFinder,
    DestinationSelector,
    ToastNotification,
    VacationSearch,
    VacationQuiz
  },
  data() {
    return {
      teamData: null
    }
  },
  mounted() {
    // If this is an admin page, redirect to admin login
    if (this.isAdminPage) {
      this.$router.push('/admin/login')
    }

    // Listen for teams-loaded event from UTD script
    window.addEventListener('teams-loaded', this.handleTeamsLoaded)
  },
  beforeDestroy() {
    // Clean up event listener
    window.removeEventListener('teams-loaded', this.handleTeamsLoaded)
  },
  methods: {
    handleTeamsLoaded(event) {
      // Store the team data for later use
      if (event.detail) {
        this.teamData = event.detail
        console.log('Team data stored:', this.teamData)
      }
    }
  },
  computed: {
    embedPage() {
      return this.shopSettings?.page?.toLowerCase()
    },
    isEmbeddedPage() {
      return this.embedPage === 'contact' || this.embedPage === 'quote' || this.embedPage === 'agent-finder' || this.embedPage === 'destination-selector' || this.embedPage === 'vakanties' || this.embedPage === 'vakantie-quiz'
    },
    isAdminPage() {
      return this.embedPage === 'admin'
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* Remove text-align center for embedded forms */
#app:has(.contact-form), 
#app:has(.quote-form) {
  text-align: left;
}
</style>
